export const sanitizeEmailAddress = (emailAddress) => {
  return emailAddress.trim();
};
